export default "assets/images/logo_circle-0582d2c7.png";